import { render, staticRenderFns } from "./InvoiceList2.vue?vue&type=template&id=7096fa2a&scoped=true&"
import script from "./InvoiceList2.vue?vue&type=script&lang=js&"
export * from "./InvoiceList2.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceList2.vue?vue&type=style&index=0&id=7096fa2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7096fa2a",
  null
  
)

export default component.exports